import { gql } from '@apollo/client';

const SEND_TEST_ACTIVATION = gql`
  mutation sendTestActivation($deviceId: String!) {
    sendTestActivation(deviceId: $deviceId)
  }
`;

export default SEND_TEST_ACTIVATION;
